

























































import { Component, Vue } from "vue-property-decorator";
import flagIcon from "../../../assets/images/flag.png";
@Component
export default class CertificationRequirements extends Vue {
  // private reqiureList = [
  //   '1、拥护党的路线、方针和政策，遵守国家法律、法规。',
  //   '2、取得经济师或相关职（执）业资格后，年度考核均为合格以上。',
  //   '第八条 学历及资历符合下列条件之一：',
  //   '①具备博士学位，取得经济师职称或相关职（执）业资格后，从事与人力资源管理相关工作满2年。具备硕士学位，或第二学士学位或研究生班毕业，或大学本科学历或学士学位，取得经济师职称或相关职（执）业资格后，从事与人力资源管理相关工作满5年',
  //   '②具备大学专科学历，取得经济师职称或相关职（执）业资格后，从事与人力资源管理相关工作满10年。不具备上述规定学历，需通过考试取得经济师职称后，在从事人力资源管理相关工作满15年。',
  //   '③具有会计、统计、审计中级专业技术资格，符合相应学历、年限条件。',
  //   '3、已具备其他系列高级职称的人员，须现在人力资源管理专业岗位工作，并取得经济师或相关职（执）业资格满1年以上，且业务考试合格。',
  //   '4、具有企业人力资源管理师、劳动关系协调师国家职业资格一级证书满2年。',
  // ]
  private flagIcon = flagIcon;
}
